// src/components/register/services/registerService.js

export const registerUser = async (payload) => {
    const apiUrl = process.env.REACT_APP_API_URL_PROD + '/register';


    const formDataPayload = new FormData();


    Object.keys(payload).forEach((key) => {

        if (payload[key] !== null && payload[key] !== undefined) {
            formDataPayload.append(key, payload[key]);
        }
    });


    const response = await fetch(apiUrl, {
        method: 'POST',

        body: formDataPayload
    });

    if (!response.ok) {
        if (response.status === 413) {
            throw new Error('Los archivos adjuntos superan el tamaño máximo permitido por el servidor.');
        }
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error en el registro: Código ${response.status}`);
    }

    return response.json();
};